const FIRST_SLOT_MINUTES = 9 * 60
const SLOT_MINUTES = 30

const SLOT_COUNT_BY_CALENDAR = {
    PICK_UP_NEW: 17,
    PICK_UP_REPAIRS: 17,
    US_AGENT: 27,
}
const DEFAULT_SLOT_COUNT = 12

export const getMeetingSlotCount = (calendar) =>
    SLOT_COUNT_BY_CALENDAR[(calendar || '').toUpperCase()] ||
    DEFAULT_SLOT_COUNT

export const getMeetingTimeSlots = (calendar) =>
    Array.from({ length: getMeetingSlotCount(calendar) }, (_, index) => {
        const minutes = FIRST_SLOT_MINUTES + index * SLOT_MINUTES
        const m = String(minutes % 60).padStart(2, '0')

        return `${Math.floor(minutes / 60)}:${m}`
    })
